import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import {
  Card, CardBody,
  Container, Row, Col, Badge, Button, Spinner,
} from "reactstrap";
import { dealsRepo } from "data/repositories/dealsRepo";
import { provincesRepo } from "data/repositories/provincesRepo";
import { placesClient } from "data/client/placesClient";
import ThemeBadge from "components/ThemeBadge";
import FavoriteButton from "components/FavoriteButton";
import EmptyState from "components/EmptyState";

export default function DealDetail() {
  const { id } = useParams();
  const [deal, setDeal] = useState(null);
  const [province, setProvince] = useState(null);
  const [hotels, setHotels] = useState([]);
  const [hotelsLoading, setHotelsLoading] = useState(false);
  const [hotelsError, setHotelsError] = useState("");

  useEffect(() => {
    const d = dealsRepo.getById(id);
    setDeal(d);
    if (d?.provinceId) {
      const prov = provincesRepo.getById(d.provinceId);
      setProvince(prov);

      setHotelsLoading(true);
      placesClient
        .searchHotels(prov?.name || d.provinceId, 6)
        .then(setHotels)
        .catch((err) => setHotelsError(err.message))
        .finally(() => setHotelsLoading(false));
    }
  }, [id]);

  if (!deal) {
    return (
      <>
        <div className="header bg-gradient-success pb-6 pt-5 pt-md-7" />
        <Container className="mt--6" fluid>
          <EmptyState title="Fırsat bulunamadı" />
        </Container>
      </>
    );
  }

  return (
    <>
      <div className="header bg-gradient-success pb-6 pt-5 pt-md-7">
        <Container fluid>
          <h1 className="text-white mb-1">{deal.title}</h1>
          <p className="text-white opacity-8 mb-0">{province?.name || deal.provinceId}</p>
        </Container>
      </div>

      <Container className="mt--6" fluid>
        <Card className="shadow mb-4">
          <CardBody>
            <Row>
              <Col md={8}>
                <h4>Detay</h4>
                <p className="text-muted">{deal.description}</p>
                {deal.theme && <ThemeBadge theme={deal.theme} />}
              </Col>
              <Col md={4}>
                <Card className="bg-secondary shadow-sm">
                  <CardBody>
                    <Badge color="success" className="mb-2 d-block text-center" style={{ fontSize: "1rem" }}>
                      {deal.priceText}
                    </Badge>
                    {deal.validUntil && (
                      <p className="small text-muted text-center mb-2">
                        Son geçerlilik: {deal.validUntil}
                      </p>
                    )}
                    <FavoriteButton type="deal" id={deal.id} />
                    {province && (
                      <Button
                        color="info"
                        block
                        size="sm"
                        className="mt-2"
                        tag={Link}
                        to={`/admin/provinces/${province.id}`}
                      >
                        {province.name} sayfasına git
                      </Button>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </CardBody>
        </Card>

        <Button color="secondary" tag={Link} to="/admin/deals">
          <i className="fas fa-arrow-left mr-1" /> Tüm fırsatlar
        </Button>


        <div className="mt-4">
          <h4 className="mb-3">
            <i className="fas fa-hotel mr-2 text-primary" />
            {province?.name || deal.provinceId} bölgesindeki oteller
            <small className="text-muted ml-2">(Google Yerler)</small>
          </h4>

          {hotelsLoading && (
            <div className="text-center py-4">
              <Spinner color="primary" />
              <p className="text-muted mt-2">Oteller yükleniyor...</p>
            </div>
          )}

          {hotelsError && (
            <Card className="shadow-sm mb-3 border-left border-warning" style={{ borderLeftWidth: 4 }}>
              <CardBody>
                <p className="text-muted mb-0">
                  <i className="fas fa-exclamation-triangle text-warning mr-2" />
                  {hotelsError}
                </p>
              </CardBody>
            </Card>
          )}

          {!hotelsLoading && !hotelsError && hotels.length === 0 && (
            <EmptyState title="Otel bulunamadı" description="Bu bölgede Google Yerler'de otel sonucu yok." />
          )}

          <Row>
            {hotels.map((h) => (
              <Col key={h.id} lg={4} md={6} xs={12} className="mb-3">
                <Card className="shadow h-100">
                  <CardBody>
                    <h5 className="mb-1">{h.displayName?.text || "İsimsiz"}</h5>
                    <p className="text-muted small mb-2">{h.formattedAddress}</p>
                    <div className="d-flex align-items-center">
                      {h.rating && (
                        <Badge color="warning" className="mr-2">
                          <i className="fas fa-star mr-1" />{h.rating}
                        </Badge>
                      )}
                      {h.userRatingCount && (
                        <small className="text-muted">({h.userRatingCount} değerlendirme)</small>
                      )}
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </Container>
    </>
  );
}
